export const categories = [
  {
    id: 'cat-1',
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '最新娱乐圈八卦新闻、明星动态、综艺热点资讯汇总',
    icon: 'ri-emotion-laugh-line',
    articleCount: 128,
  },
  {
    id: 'cat-2',
    slug: 'shehui-redian',
    name: '社会热点',
    description: '社会热点事件深度分析、民生话题讨论与追踪报道',
    icon: 'ri-fire-line',
    articleCount: 96,
  },
  {
    id: 'cat-3',
    slug: 'wangluo-chigua',
    name: '网络吃瓜',
    description: '最新网络热门话题、争议事件、网红八卦一网打尽',
    icon: 'ri-emotion-happy-line',
    articleCount: 85,
  },
  {
    id: 'cat-4',
    slug: 'keji-shuma',
    name: '科技数码',
    description: '科技圈最新动态、数码产品评测、行业深度分析',
    icon: 'ri-computer-line',
    articleCount: 74,
  },
  {
    id: 'cat-5',
    slug: 'shishang-meizhuang',
    name: '时尚美妆',
    description: '时尚潮流趋势、美妆护肤心得、穿搭搭配指南',
    icon: 'ri-palette-line',
    articleCount: 63,
  },
  {
    id: 'cat-6',
    slug: 'tiyu-dianjing',
    name: '体育电竞',
    description: '体育赛事速报、电竞比赛战况、运动明星资讯',
    icon: 'ri-gamepad-line',
    articleCount: 58,
  },
  {
    id: 'cat-7',
    slug: 'caijing-shangye',
    name: '财经商业',
    description: '财经新闻速递、商业案例分析、投资理财知识',
    icon: 'ri-line-chart-line',
    articleCount: 47,
  },
  {
    id: 'cat-8',
    slug: 'shenghuo-qinggan',
    name: '生活情感',
    description: '生活感悟分享、情感故事、人际关系探讨与交流',
    icon: 'ri-heart-line',
    articleCount: 42,
  },
];